import React from "react";

const IconContactsFilled = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path
        d="M2 20c0-1.2 1.4-6 5.58-6h2.84C14.6 14 16 18.8 16 20H2zm16.014-5C21 15 22 19 22 20h-4c0-.85-.66-3.247-2-5h2.014zM5.464 4.464A4.984 4.984 0 0 1 9 3c1.38 0 2.63.56 3.536 1.464A4.984 4.984 0 0 1 14 8c0 1.38-.56 2.63-1.464 3.536A4.984 4.984 0 0 1 9 13c-1.38 0-2.63-.56-3.536-1.464A4.984 4.984 0 0 1 4 8c0-1.38.56-2.63 1.464-3.536zM20 11.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default IconContactsFilled;
